import { deviceMappingListQuerySchema, unmappedDeviceListQuerySchema } from '@chukua/common';
import { useEffect, useState } from 'react';
import { listDeviceMappings, listUnmappedDevices } from '../gps.api';

export interface GpsIntegrationCounts {
  /** Devices on a truck now. */
  mapped: number;
  /** Devices reporting positions that no truck owns. */
  unmapped: number;
}

/** One integration's device health for its row: two counts, read from the totals of one-row pages. Undefined until both arrive or if either fails. */
export function useGpsIntegrationCounts(integrationId: string): GpsIntegrationCounts | undefined {
  const [counts, setCounts] = useState<GpsIntegrationCounts | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    Promise.all([
      listDeviceMappings({ ...deviceMappingListQuerySchema.parse({ current: 'true', pageSize: 1 }), integrationId: [integrationId] }),
      listUnmappedDevices({ ...unmappedDeviceListQuerySchema.parse({ pageSize: 1 }), integrationId: [integrationId] }),
    ])
      .then(([mapped, unmapped]) => !cancelled && setCounts({ mapped: mapped.total, unmapped: unmapped.total }))
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [integrationId]);

  return counts;
}
